export default async function enviarAssinatura({
    nomeEmpresa,
    emailPrincipal,
    emailAlternativo,
    cpfCnpj,
    cep,
    endereco,
    complemento,
    estado,
    cidade,
    bairro,
    telefone,
    periodoSelecionado,
    dominio,
    tipoDominio,
    planoSelecionado,
    cupomValido,
    calcularValorTotal,
    cupom,
    indicacao,
    infoAdicional,
    captchaToken,
    router
  }) {
    const detalhesPlano = `
      PLANO ${planoSelecionado.value.nome}
  
      Recursos:
      - CPU: ${planoSelecionado.value.processamento} vCore @ Intel Xeon 3.5Ghz
      - Espaço Disco: ${planoSelecionado.value.disco} GB de SSD
      - Memória: ${planoSelecionado.value.ram1} GB de RAM
      - Tráfego: Ilimitado
      - IP dedicado: 2
  
      Painel de Controle:
      - WHM /cPanel
      - Contas cPanel: ${planoSelecionado.value.dominios}
      - Integrator Java EE
      - Integrator Node.js
      - Integrator Spring Boot
      - Integrator Https
      - Integrator Custom Erro

      Tecnologia:
      - ${planoSelecionado.value.tecnologia}
  
      Banco de Dados:
      - ${planoSelecionado.value.banco}
  
      Domínios:
      - Domínios: Ilimitados
      - Subdomínios: ${planoSelecionado.value.subdominios}
      - SSL Incluso em todos
  
      E-mail:
      - Caixas de E-mail: ${planoSelecionado.value.emails}
      - Tamanho da Caixa: Flexível
  
      Sistema Operacional:
      - Almalinux 9

      Outros:
      - Anti-DDoS Incluso
      - Antivirus
      - Acesso Root
      - Instalador Automático: WordPress + 382 scripts

    `.trim()
  
    const valorTotal = calcularValorTotal(
      planoSelecionado?.value || null,
      periodoSelecionado?.value || 1,
      cupomValido?.value || null
    )
  
    //console.log('[DEBUG] planoSelecionado:', planoSelecionado.value)
    //console.log('[DEBUG] periodoSelecionado:', periodoSelecionado.value)
    //onsole.log('[DEBUG] cupomValido:', cupomValido?.value)
    //console.log('[DEBUG] captchaToken:', captchaToken)
  
    
    const registrarDominioDescricao = {
      'registro': 'Sim, registrar domínio pela Integrator',
      'ja-tenho': 'Não, já possui domínio registrado',
      'subdominio': 'Subdomínio temporário grátis'
    }
  
    const payload = {
      nome: nomeEmpresa.value,
      empresa: nomeEmpresa.value,
      email: emailPrincipal.value,
      email_copia: emailAlternativo.value,
      cpf_cnpj: cpfCnpj.value,
      cep: cep.value,
      endereco: endereco.value,
      complemento: complemento.value,
      estado: estado.value,
      cidade: cidade.value,
      bairro: bairro.value,
      tel_cel: telefone.value,
      pagamento: periodoSelecionado.value,
      dominio: dominio.value && dominio.value.trim() !== '' ? dominio.value : 'subdominio-gratis.com.br',
      plano: detalhesPlano,
      dominio_registro: registrarDominioDescricao[tipoDominio.value], 
      envio: 1,
      cliente_usuario: 0,
      cliente_revenda: 0,
      cliente_adicional: 0,
      indicacao: indicacao.value,
      cupom: cupom.value,
      infoAdicional: infoAdicional.value,
      data_cadastro: new Date().toISOString().split('T')[0],
     // valor: parseFloat(valorTotal.replace(',', '.')) 
      valor: valorTotal,
      captchaToken: captchaToken
    }
    //console.log('🛰️ Enviando para a API TOKEN:', payload.captchaToken) // 👈 Aqui você vê tudo no console
  
  
  
    try {
      const res = await fetch(`${import.meta.env.VITE_API_BASE_URL}/api/temporarios/salvar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include', // importante se você estiver usando cookies
        body: JSON.stringify(payload)
      })
    
      if (!res.ok) {
        throw new Error('Erro ao enviar os dados da assinatura')
      }
    
      const resposta = await res.json()
    
      router.push({
        path: '/assineja-finalizada',
        query: {
          id: resposta.clienteIdB,
          email: emailPrincipal.value,
          valor: valorTotal,
          telefone: telefone.value
        }
      })
    } catch (error) {
      console.error('Erro ao enviar assinatura:', error)
      alert('Erro ao enviar os dados. Tente novamente mais tarde.')
    }
  
  }
  